<template>
  <div
    id="chat"
    class="bg-white px-3"
    style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
  >
    <div class="mb-2 mt-2 pt-3 sertop">
      <!-- 左边 -->
      <div class="sertop-left">
        <span class="mr-2">当前查看主播：</span>
        <div>
          <el-avatar class="mr-4" :src="thehostall.portrait"></el-avatar>
        </div>
        <div>
          <el-tag class="mr-4">名称：{{ thehostall.nickname }} </el-tag>
        </div>
        <el-tag class="mr-4">id：{{ thehostall.id }}</el-tag>
        <el-tag class="mr-4">uid：{{ thehostall.free_id }}</el-tag>
        <el-tag class="mr-4">fid：{{ thehostall.free_fid }}</el-tag>
      </div>

      <div class="sertop-right">
        <el-form inline ref="form" :model="from" label-width="100px">
          <el-form-item label="" size="small" class="mb-0">
            <span>主播搜索：</span>
            <el-autocomplete
              class="inline-input"
              v-model="thehost"
              clearable
              :fetch-suggestions="querySearch"
              placeholder="请输入主播名称"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>

          <el-form-item class="mb-0">
            <el-button type="info" @click="searchEvent()" size="small"
              >搜索
            </el-button>
            <el-button size="small" @click="clearSearch"
              >清空筛选条件</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 表格 -->
    <div class="mt-3 pt-2">
      <el-table
        :data="tableData"
        @sort-change="sortChange"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed
          align="center"
          type="index"
          label="排序"
          width="50"
        />
        <el-table-column align="center" prop="nickname" label="对方昵称" />
        <el-table-column align="center" prop="ptime" label="聊天创建时间" />
        <el-table-column align="center" label="操作">
          <template slot-scope="v">
            <el-button plain @click="looklist(v.row)"
              >查看记录（{{ v.row.chatversion }}）</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="height: 60px"></div>
    <el-footer
      class="d-flex border-top bg-white align-items-center px-0 position-fixed"
      style="bottom: 0; left: 200px; right: 0; z-index: 100"
    >
      <!-- 底部 -->

      <div style="flex: 1" class="px-2">
        <el-pagination
          :current-page="page.current"
          :page-sizes="page.sizes"
          :page-size="page.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </el-footer>

    <el-dialog width="80%" title="消息详情" :visible.sync="chstshow">
      <div class="mt-3 pt-2">
        <el-table
          :data="tableDatatwo"
          @sort-change="sortChangetwo"
          border
          v-loading="loadingtwo"
          style="width: 100%"
          max-height="450"
        >
          <el-table-column
            fixed
            align="center"
            label="编号"
            width="50"
            prop="chatmsgno"
          >
          </el-table-column>
          <el-table-column align="center" prop="nickname" label="发送人" />
          <el-table-column align="center" prop="content" label="内容">
            <template slot-scope="v">
              <span v-if="v.row.msgtype == 1">{{ v.row.content }}</span>
              <img
                v-else-if="v.row.msgtype == 4 && v.row.img"
                :src="v.row.img.url"
                style="width: 100%"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column align="center" prop="msgtime" label="时间" />
        </el-table>
      </div>

      <div style="height: 60px"></div>
      <el-footer>
        <!-- 底部 -->

        <div style="flex: 1" class="px-2">
          <el-pagination
            :total="pagetwo.total"
            :current-page="pagetwo.current"
            :page-sizes="pagetwo.sizes"
            :page-size="pagetwo.size"
            @size-change="handleSizeChangetwo"
            @current-change="handleCurrentChangetwo"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </el-footer>
    </el-dialog>
  </div>
</template>

<script>
import common from "@/common/mixins/common.js";
export default {
  inject: ["layout"],
  mixins: [common],
  data() {
    return {
      editIndex: -1,
      //搜索数据
      from: {
        id: "",
        u_id: "",
        username: "",
        type: -1,
        time: [],
        host_id: "",
      },
      model_title: "Host",
      auth_val: "Mtlog",
      preUrl: "data/chatList", //列表地址

      tableData: [],
      tableDatatwo: [],
      loadingtwo: false,
      pagetwo: {
        current: 1,
        sizes: [10, 20, 50, 100],
        size: 10,
        total: 0,
      },
      proptwo: "",
      sorttwo: "descending",
      form: {
        id: 0,
        remark: "",
      },
      prop: "",
      sort: "descending",
      rule_list: [],
      check_img_list: [],
      cz_money: 0,
      tx_money: 0,
      chstshow: false,
      contenttitle: "",
      thehost: "", // 选中的主播名称
      thehostall: {}, // 选中的主播所有数据
      userlist: [], // 全部主播
      restaurants: [],
      chatkeydata: {}, // 聊天key
    };
  },
  watch: {},
  created() {
    //this.commonList('rule');
  },
  methods: {
    sortChange(column) {
      this.prop = column.prop;
      this.sort = column.order;
      this.getList();
    },
    sortChangetwo(column) {
      this.proptwo = column.prop;
      this.sorttwo = column.order;
      this.lisktget();
    },
    //提交
    submit() {
      this.$refs.form.validate((res) => {
        if (res) {
          //this.form.default = this.form.default.replace(/\n/g,',')
          this.form.id = this.editIndex;
          this.addOrEdit(this.form);
          // 关闭模态框
        }
      });
    },
    // 查看消息详情
    looklist(data) {
      if (data.chatkey) {
        this.chatkeydata = data;
        this.loadingtwo = true;
        this.pagetwo = {
          current: 1,
          sizes: [10, 20, 50, 100],
          size: 10,
          total: 0,
        };
        this.chstshow = true;
        this.lisktget();
      }
    },
    handleSizeChangetwo(val) {
      this.pagetwo.size = val;
      this.lisktget();
    },
    handleCurrentChangetwo(val) {
      this.pagetwo.current = val;
      this.lisktget();
    },
    handleSelect(item) {
      // 模糊搜索选中后
      this.from.host_id = item.id;
      // console.log(item);
    },
    // 筛选条件
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    loadAll() {
      return this.userlist;
    },
    lisktget() {
      this.api
        .post(
          "/data/chatDetail",
          {
            chatkey: this.chatkeydata.chatkey,
            page: this.pagetwo.current,
            limit: this.pagetwo.size,
            prop: this.proptwo,
            sort: this.sorttwo == "ascending" ? "asc" : "desc",
          },
          
        )
        .then((res) => {
          this.tableDatatwo = [];
          let dataall = res.data.data.list.data.msgList;
          for (let i in dataall) {
            // 类型为文字和图片的显示，其他不要
            if (dataall[i].msgtype == 1 || dataall[i].msgtype == 4) {
              this.tableDatatwo.push(dataall[i]);
            }
          }
          // console.log(this.tableDatatwo, "----");
          this.pagetwo.total = res.data.data.list.total;
          this.loadingtwo = false;

          for (let i in this.tableDatatwo) {
            // 时间戳转化为日期
            this.tableDatatwo[i].msgtime = new Date(
              parseInt(this.tableDatatwo[i].msgtime) * 1000
            )
              .toLocaleString()
              .substr(0, 17);

            if (this.tableDatatwo[i].uid == this.thehostall.free_id) {
              // 如果是主播，就返回当前主播名称
              this.tableDatatwo[i].nickname = this.thehostall.nickname;
            } else {
              // 如果是用户，就返回用户名称
              this.tableDatatwo[i].nickname = this.chatkeydata.nickname;
            }
            if (this.tableDatatwo[i].msgtype == 4) {
              this.tableDatatwo[i].img = JSON.parse(
                this.tableDatatwo[i].content
              );
            }
          }
          // console.log(this.chatkeydata, "聊天内容");
          // console.log(this.tableDatatwo, "所有数据");
        })
        .catch((err) => {
          this.loadingtwo = false;
        });
    },
    getListResult(e) {
      // console.log(e.check_user);
      const data = e.data.chatlist;
      // console.log(e);
      this.userlist = [];
      for (let i in e.user_list) {
        this.userlist.push({
          value: e.user_list[i].nickname,
          free_fid: e.user_list[i].free_fid,
          free_id: e.user_list[i].free_id,
          id: e.user_list[i].id,
          portrait: e.user_list[i].portrait,
        });
      }
      this.restaurants = this.userlist;
      // console.log(this.userlist);
      this.thehostall = e.check_user ? e.check_user : {};
      for (let i in data) {
        if (data[i].ptime) {
          // 时间戳转换
          data[i].ptime = new Date(parseInt(data[i].ptime) * 1000)
            .toLocaleString()
            .replace(/:\d{1,2}$/, " ");
        }
      }
      this.tableData = data;
      console.log(e, "---");
    },
    // 清空筛选条件
    clearSearch() {
      this.from = {
        id: "",
        u_id: "",
        username: "",
        type: -1,
        time: [],
        host_id: "",
      };
      (this.thehost = ""), (this.thehostall = {}), (this.search = "");
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.sertop {
  display: flex;
  align-items: center;
  padding-top: 20px;
  justify-content: space-between;
  .sertop-left {
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
    }
  }
  .sertop-right {
    .el-form {
      display: flex;
      align-items: center;
    }
  }
}
</style>
